/** Предел промта, который человек пишет сам (описание «Фото» и «Видео», пожелания, тема, идея, «Улучшить»): 5000 знаков
    (05.11.2026, раньше 500; на бэкенде — MessagingPromptLimits.Max). Сервер присылает свой предел в форме — он главный, это запасной. */
export const PROMPT_MAX = 5000;
